import React from 'react';
import CurricularClass32023 from 'views/CurricularClass52023/CurricularClass32023';

const ExtraCurricularActivitiesPage = () => {
  return <CurricularClass32023 />;
};

export default ExtraCurricularActivitiesPage;
